/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIArticleFile
 */
export interface APIArticleFile {
    /**
     * 
     * @type {string}
     * @memberof APIArticleFile
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFile
     */
    article: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFile
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFile
     */
    document?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticleFile
     */
    readonly name: string;
    /**
     * 
     * @type {Date}
     * @memberof APIArticleFile
     */
    readonly storedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIArticleFile
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {number}
     * @memberof APIArticleFile
     */
    readonly size: number;
}

/**
 * Check if a given object implements the APIArticleFile interface.
 */
export function instanceOfAPIArticleFile(value: object): value is APIArticleFile {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('article' in value) || value['article'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('storedAt' in value) || value['storedAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    return true;
}

export function APIArticleFileFromJSON(json: any): APIArticleFile {
    return APIArticleFileFromJSONTyped(json, false);
}

export function APIArticleFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticleFile {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'article': json['article'],
        'key': json['key'] == null ? undefined : json['key'],
        'document': json['document'] == null ? undefined : json['document'],
        'name': json['name'],
        'storedAt': (new Date(json['stored_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'size': json['size'],
    };
}

export function APIArticleFileToJSON(value?: Omit<APIArticleFile, 'self'|'name'|'stored_at'|'last_modified_at'|'size'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'article': value['article'],
        'key': value['key'],
        'document': value['document'],
    };
}

